export const saveFile = (data, file, type) => {
    const blob = new Blob([data], {type});
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = file;
    link.click();
};